
import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

interface NotificationSettingsProps {
  initialSettings?: {
    notifyOnBooking: boolean;
    notifyOnCancellation: boolean;
    notifyOnReminder: boolean;
    emailAddress?: string;
    phoneNumber?: string;
  };
  onSave?: (settings: any) => void;
}

export function NotificationSettings({ 
  initialSettings,
  onSave 
}: NotificationSettingsProps) {
  const [settings, setSettings] = useState({
    notifyOnBooking: initialSettings?.notifyOnBooking ?? true,
    notifyOnCancellation: initialSettings?.notifyOnCancellation ?? true,
    notifyOnReminder: initialSettings?.notifyOnReminder ?? true,
    emailAddress: initialSettings?.emailAddress ?? "",
    phoneNumber: initialSettings?.phoneNumber ?? ""
  });
  
  const handleChange = (field: string, value: boolean | string) => {
    setSettings(prev => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    if (onSave) {
      onSave(settings);
    }
    toast.success("Notification settings saved");
  };
  
  return (
    <div>
      <Card>
        <CardHeader>
          <CardTitle>Notifications</CardTitle>
          <CardDescription>
            Figgy can text you important booking updates. Client confirmations, reminders, and manage-booking links are handled automatically by Figgy.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-3">
            <div className="flex items-center space-x-2">
              <Switch
                id="notifyBooking"
                checked={settings.notifyOnBooking}
                onCheckedChange={(checked) => handleChange("notifyOnBooking", checked)}
              />
              <Label htmlFor="notifyBooking">Text me when I get a new booking</Label>
            </div>

            <div className="flex items-center space-x-2">
              <Switch
                id="notifyCancellation"
                checked={settings.notifyOnCancellation}
                onCheckedChange={(checked) => handleChange("notifyOnCancellation", checked)}
              />
              <Label htmlFor="notifyCancellation">Text me when a booking is cancelled</Label>
            </div>

            <div className="flex items-center space-x-2">
              <Switch
                id="notifyReminder"
                checked={settings.notifyOnReminder}
                onCheckedChange={(checked) => handleChange("notifyOnReminder", checked)}
              />
              <Label htmlFor="notifyReminder">Send clients appointment reminders</Label>
            </div>
          </div>
          
          <div className="flex justify-end">
            <Button onClick={handleSave} className="bg-figgy-500 hover:bg-figgy-600">
              Save Notification Settings
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
